import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authApi from "../../services/authApi";
import handleAsyncThunk from "../handleAsyncThunk";
import { storage } from "../../config/storage";
import { showErrorSnackbar } from "./snackbarSlice";

// SIGNUP API
export const getUserDetails = createAsyncThunk(
    "/getUser",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await authApi.getUserProfileDetails();
            if (response.status === 0) {
                // update stored user
                storage.setInLocalStorage.user(response?.data);

                // update state
                dispatch(updateData({ isSignedIn: true, user: response?.data }));
                return response?.data; // Return the response data on success
            } else {
                dispatch(logMeOut())
                return rejectWithValue(response?.data?.message); // Reject with error message
            }
        } catch (error) {
            dispatch(logMeOut())
            console.log(error);
            dispatch(showErrorSnackbar({ title: error?.message }));
            return rejectWithValue(error.message); // Handle unexpected errors
        }
    }
);
 

const userSlice = createSlice({
    name: 'user',
    initialState: {
        isLoading: false,
        userDetailsLoading: true,
        user: storage.fetchFromLocalStorage.user() || null,
        token: storage.fetchFromLocalStorage.token() || null,
        isSignedIn: (storage.fetchFromLocalStorage.user() && storage.fetchFromLocalStorage.token()) ? true : false,
        loginError: null
    },
    reducers: {
        // This reducer will be called once the user logs in successfully!
        logMeIn: (state, action) => {
            // set token
            if(action.payload?.token)
                storage.setInLocalStorage.token(action.payload?.token);
            // set user
            if(action.payload?.user)
                storage.setInLocalStorage.user(action.payload?.user);

            // action.payload
            // {
            //     user,
            //     token,
            // }

            // Defaults:
            //     isSignedIn: true
            state.user = action.payload?.user;
            state.token = action.payload?.token;
            state.isSignedIn = true;
        },
        // This reducer will be called once the user logs out successfully!
        logMeOut: (state, action) => {
            // delete session key
            storage.destroyFromSessionStorage.sessionKey();
            // delete access token
            storage.destroyFromLocalStorage.token();
            // delete user from localstorage
            storage.destroyFromLocalStorage.user();
            // delete if any navigateOnLogin
            storage.destroyFromLocalStorage.navigateOnLogin();
            
            // action.payload
            // {
            //     error,
            // }

            // Defaults: 
            //     isSignedIn: false
            //     user: null
            //     token: null
            state.user = null;
            state.token = null;
            state.isSignedIn = false;
            if(action.payload?.error) {
                state.loginError = action.payload?.error;
            }

            // window.location.reload();
        },
        // This reducer will update Data
        updateData: (state, action) => {
            // action.payload
            // {
            //     isSignedIn,
            //     user,
            //     token (optional)
            // }

            if(action.payload?.isSignedIn) {
                state.isSignedIn = action.payload?.isSignedIn;
            }
            if(action.payload?.user) {
                state.user = action.payload?.user;
            }
            if(action.payload?.token) {
                state.token = action.payload?.token;
            }
        }
    },
    extraReducers: (builder) => {
        handleAsyncThunk(builder, getUserDetails, "user", "error", "userDetailsLoading");
    }
})

export const { logMeIn, logMeOut, updateData } = userSlice.actions

export default userSlice.reducer